import ImageWithSkeleton from './ComponentsPage/ImageWithSkeleton';

export default function HeroSection() {
  return (
    <div className="relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-10 sm:pt-60 lg:pt-32 pb-12 sm:pb-20">
        <div className="mx-auto max-w-2xl lg:max-w-none lg:flex lg:items-center lg:gap-12">
          {/* Copy */}
          <div className="relative w-full lg:max-w-xl lg:shrink-0 xl:max-w-2xl">
            <h1 className="text-2xl font-bold tracking-tight text-pretty text-primary-main">
              About KiN Space
            </h1>
            <p className="mt-4 text-base text-pretty text-kin-text">
              KiN (Kids Nusantara) is an ode to Nusantara, where Indonesia’s rich culture inspires
              the space, activity, and the brand’s roots. Our mission is to captivate young minds
              and nurture well-being through Indonesian art and culture.
              <br />
              <br />
              We blend education with imagination, offering a gateway to explore the wonders of
              Nusantara. KiN Space is in SCBD Park, Jakarta. This family space offers a unique blend
              of exhibition, play, learning, gallery, retail, and a cozy cafe.
            </p>
          </div>

          <div className="mt-10 lg:mt-0 lg:flex-1">
            <div className="grid grid-cols-3 gap-3 md:gap-3 lg:grid-cols-2 xl:grid-cols-3 lg:gap-3 lg:pl-0">
              {/* Col A */}
              <div className="col-span-1 space-y-3 lg:hidden xl:block lg:pt-0 xl:pt-16">
                <ImageWithSkeleton
                  src="kin/assest/about/kininstallation/eko/art1.webp"
                  alt="KiNSTALLATION – Eko Nugroho"
                />
                <ImageWithSkeleton
                  src="kin/assest/about/kininstallation/mangmoel/art1.webp"
                  alt="KiNSTALLATION – Mang Moel"
                />
              </div>

              {/* Col B */}
              <div className="col-span-1 flex-none space-y-3 lg:pt-36">
                <ImageWithSkeleton
                  src="kin/assest/about/kininstallation/citra_novieta/art1.webp"
                  alt="KiNSTALLATION – Mountain Song"
                />
                <ImageWithSkeleton
                  src="kin/assest/about/kininstallation/eldwin/art2.webp"
                  alt="KiNSTALLATION – Eldwin Pradipta"
                />
              </div>

              {/* Col C */}
              <div className="col-span-1 flex-none space-y-3 lg:pt-0">
                <ImageWithSkeleton
                  src="kin/assest/about/kininstallation/citra_novieta/art2.webp"
                  alt="KiNSTALLATION – Mountain Song 2"
                />
                <ImageWithSkeleton
                  src="kin/assest/about/kininstallation/mangmoel/art3.webp"
                  alt="KiNSTALLATION – Mang Moel 3"
                />
              </div>
            </div>
          </div>
          {/* /Mosaic */}
        </div>
      </div>
    </div>
  );
}
